import { render, staticRenderFns } from "./ProductDelete.vue?vue&type=template&id=632f015f"
import script from "./ProductDelete.vue?vue&type=script&lang=ts"
export * from "./ProductDelete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports